import { useLocation } from '@tanstack/react-router';
import {
  APP_MENU_ITEMS,
  type AppMenuItem,
} from '@/features/dashboard/_root/appMenu.ts';

/**
 * Sekcja, w której użytkownik właśnie jest. Dopasowanie po prefiksie, bo ekran
 * rekordu (`/app/tours/{id}/info`) wciąż należy do „Moich wyjazdów”, a samo
 * porównanie równością gasiło podświetlenie po wejściu w rekord.
 */
const useActiveAppMenuItem = (): AppMenuItem | undefined => {
  const { pathname } = useLocation();

  return APP_MENU_ITEMS.find((item) => {
    const path = item.to as string;
    return pathname === path || pathname.startsWith(`${path}/`);
  });
};

export default useActiveAppMenuItem;
